import { render, staticRenderFns } from "./channelSubs.vue?vue&type=template&id=0e685bb6&scoped=true"
import script from "./channelSubs.vue?vue&type=script&lang=js"
export * from "./channelSubs.vue?vue&type=script&lang=js"
import style0 from "./channelSubs.vue?vue&type=style&index=0&id=0e685bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e685bb6",
  null
  
)

export default component.exports